import React, { useState, useEffect } from "react";
import Header from "./Header";
import Features from "./Features";
import Products from "./Products";
import { Link } from "react-router-dom";

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: "/assets/images/slider/mungbeans.jpg",
      title: "Premium Green Mung Beans",
      subtitle: "from South Wello and North Shewa",
      location: "Superior Quality from Ethiopian Soil",
    },
    {
      image: "/coffee.jpg",
      title: "Premium Quality",
      subtitle: "Ethiopian Coffee Beans", 
      location: "Direct from the Source",
    },
    {
      image: "/assets/images/slider/sesame-field.jpeg",
      title: "Premium Sesame Seeds",
      subtitle: "from the Humera Region",
      location: "Sweet & Nutty Ethiopian Sesame",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <div className="relative min-h-screen">
        <Header />
        {/* Immersive Slider */}
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-1000 ease-in-out transform ${
                index === currentSlide ? "opacity-100 scale-100" : "opacity-0 scale-105"
              }`}
            >
              <div 
                className="absolute inset-0 bg-cover bg-center animate-ken-burns"
                style={{
                  backgroundImage: `url('${slide.image}')`,
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-transparent backdrop-blur-[2px]" />
            </div>
          ))}
        </div>
        {/* Hero Content */}
        <div className="relative h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl w-full">
            <div className="space-y-6 sm:space-y-8 text-center">
             
              <h1 className="text-white font-bold leading-tight animate-fade-in-up delay-100">
                <span className="block text-3xl sm:text-3xl md:text-3xl lg:text-6xl xl:text-3xl mb-3 sm:mb-4 drop-shadow-2xl">
                  {slides[currentSlide].title}
                </span>
                <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-3 sm:mb-4 text-emerald-400 drop-shadow-2xl">
                  {slides[currentSlide].subtitle}
                </span>
                <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl opacity-90 drop-shadow-2xl">
                  {slides[currentSlide].location}
                </span>
              </h1>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-6 sm:pt-8 animate-fade-in-up delay-200">
                <Link to="/contact">
                  <button className="w-full sm:w-auto px-8 sm:px-12 py-3 sm:py-4 bg-emerald-500 text-white rounded-full text-base sm:text-lg font-semibold hover:bg-emerald-600 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-emerald-500/30">
                    Order Sample
                  </button>
                </Link>
                <Link to="/service">
                  <button className="w-full sm:w-auto px-8 sm:px-12 py-3 sm:py-4 border-2 border-white text-white rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-emerald-900 transform hover:scale-105 transition-all duration-300">
                    Services
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Refined Navigation */}
        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex items-center gap-8 z-20">
          <button
            onClick={prevSlide}
            className="p-2 text-white/70 hover:text-white transition-colors"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          
          <div className="flex gap-3">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-16 h-1.5 rounded-full transition-all duration-300 ${
                  index === currentSlide 
                    ? "bg-emerald-400 w-24" 
                    : "bg-white/30 hover:bg-white/50"
                }`}
              />
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="p-2 text-white/70 hover:text-white transition-colors"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>

      <Features />
      
      {/* Modernized Why Choose Us Section */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: "url('/assets/images/others/coffee.jpg')", backgroundAttachment: "fixed", backgroundSize: "cover", backgroundPosition: "center", opacity: 0.1 }} />
        
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center gap-16">
            <div className="lg:w-1/2">
              <div className="relative">
                <div className="absolute -inset-4 bg-emerald-500/20 rounded-[30%_70%_70%_30%/30%_30%_70%_70%] blur-2xl animate-pulse" />
                <div className="relative w-[500px] h-[500px] rounded-[60%_40%_30%_70%/60%_30%_70%_40%] overflow-hidden border-8 border-white">
                  <img
                    src="./assets/images/others/logo_grid.jpg"
                    alt="Coffee cherries"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            <div className="lg:w-1/2 space-y-8 text-right">
              <h3 className="text-5xl font-bold text-gray-900">
                Why choose us?
              </h3>
              <p className="text-xl leading-relaxed text-gray-700">
                We're passionate about delivering top-quality agricultural
                products and helping modernize farming in Ethiopia. We
                specialize in exporting premium oilseeds, cereals, and coffee,
                while also growing these crops ourselves. We're also expanding
                into importing important farming supplies and new agricultural
                technologies. On top of that, we're working on building modern
                processing plants to better serve both local and international
                markets. With us, you get a reliable partner focused on quality,
                innovation, and long-term growth.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Products />

      {/* Key Strengths Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-emerald-900 mb-4">Key Strengths</h2>
            <div className="w-24 h-1 bg-emerald-500 mx-auto"></div>
          </div>

          <div className="flex flex-wrap -mx-4">
            {[
              {
                title: "Reliable Supply Chain",
                description: "Direct agricultural production ensuring a consistent and reliable supply chain.",
              },
              {
                title: "Expert Leadership", 
                description: "Experienced leadership team with deep industry knowledge and a proven track record.",
              },
              {
                title: "Quality Commitment",
                description: "Strong commitment to delivering high-quality and reliable agricultural products.",
              },
              {
                title: "Global Partnerships",
                description: "Focused on building robust and enduring international partnerships.",
              }
            ].map((strength, index) => (
              <div key={index} className="w-full md:w-1/2 lg:w-1/4 px-4 mb-8">
                <div className="relative h-full">
                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 to-white rounded-lg transform rotate-3"></div>
                  <div className="relative bg-white p-8 rounded-lg h-full transform hover:-translate-y-2 transition-transform shadow-lg hover:shadow-xl border border-emerald-100">
                    <div className="w-16 h-16 bg-emerald-500 rounded-full mb-6 flex items-center justify-center">
                      <span className="text-2xl text-white font-bold">{index + 1}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-emerald-800 mb-4 text-left">
                      {strength.title}
                    </h3>
                    <p className="text-emerald-600 text-left">
                      {strength.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
